import type { PageTab } from '@mdvip/shared/components/blocks/PageTabs';
import { PageTabPanel, PageTabs } from '@mdvip/shared/components/blocks/PageTabs';
import { useTranslation } from 'react-i18next';

import { EmptyStateIllustration } from '@/components/icons/EmptyStateIllustration';
import { Navigation } from '@/components/Navigation';
import { ClevelandHeartLab } from '@/components/resources/operations/ClevelandHeartLab';

export function ResourcesPage() {
  const { t } = useTranslation('providers');

  const tabs: PageTab[] = [
    { value: 'medical', label: t('pages.resources.tabs.medical') },
    { value: 'operations', label: t('pages.resources.tabs.operations') },
    { value: 'wellness', label: t('pages.resources.tabs.wellness') },
  ];

  return (
    <div className="min-h-screen bg-background pb-20 md:pb-6">
      <Navigation />
      <main className="container mx-auto px-4 py-6 max-w-7xl">
        <div className="mb-6">
          <h1 className="text-2xl font-bold">{t('pages.resources.title')}</h1>
          <p className="text-sm text-muted-foreground mt-1">{t('pages.resources.subtitle')}</p>
        </div>
        <PageTabs tabs={tabs} defaultValue="medical">
          <PageTabPanel value="medical">
            <div className="flex flex-col items-center justify-center border-2 border-dashed border-border rounded-xl py-16 gap-4">
              <EmptyStateIllustration className="w-48 opacity-40" />
              <p className="text-muted-foreground text-sm">{t('pages.resources.empty.medical')}</p>
            </div>
          </PageTabPanel>
          <PageTabPanel value="operations">
            <ClevelandHeartLab />
          </PageTabPanel>
          <PageTabPanel value="wellness">
            <div className="flex flex-col items-center justify-center border-2 border-dashed border-border rounded-xl py-16 gap-4">
              <EmptyStateIllustration className="w-48 opacity-40" />
              <p className="text-muted-foreground text-sm">{t('pages.resources.empty.wellness')}</p>
            </div>
          </PageTabPanel>
        </PageTabs>
      </main>
    </div>
  );
}
